import React, { Component } from 'react';
import PropTypes from 'prop-types'; // eslint-disable-line import/no-extraneous-dependencies
import { Row } from '../Structure';

class Base extends Component {
  constructor(props) {
    super(props);
    this.formRef = null;

  }

  submit = () => {
    const formIsValid = this.formRef.reportValidity();
    if (formIsValid) {
      this.formRef.dispatchEvent(new Event('submit', { cancelable: true }))
    } else {
      const { onError = () => { } } = this.props;
      onError();
    }
  }

  getFormRef = (ref) => this.formRef = ref;

  render() {
    const { formTitle, children, onSubmit } = this.props;
    return (
      <Row>
        { formTitle }
        <form className="FormContainer" onSubmit={ onSubmit } ref={ this.getFormRef }>
          { children }
        </form>
      </Row>
    );
  }
};

Base.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  formTitle: PropTypes.string,
  onSubmit: PropTypes.func,
  onError: PropTypes.func,
};

Base.defaultProps = {
  children: [],
  formTitle: '',
  onSubmit: () => { },
  onError: () => { },
};

export default Base;
